/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: systemMisc.types.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    TypeScript type definitions for System Misc frontend module.
────────────────────────────────────────────────────────────────*/

export interface SystemMiscConfig {
  id: string | number;
  uuid?: string;
  name: string;
  serverId?: string | number | null;
  timezone?: string;
  logLevel?: string;
  maintenanceMode?: boolean;
  server?: {
    id: string | number;
    uuid?: string;
    name?: string;
    host?: string;
    status?: string;
    telephonyStatus?: string;
    monitoringEnabled?: boolean;
    lastSeen?: string | null;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface ListSystemMiscResponse {
  success: boolean;
  data: SystemMiscConfig[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface FetchSystemMiscParams {
  page: number;
  limit: number;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  search?: string;
}

export const STATUS_BADGES: Record<
  string,
  {
    className: string;
    labelKey: string;
  }
> = {
  online: { className: 'bg-green-100 text-green-800', labelKey: 'systemMisc.statusLabels.online' },
  active: { className: 'bg-green-100 text-green-800', labelKey: 'systemMisc.statusLabels.online' },
  offline: { className: 'bg-red-100 text-red-800', labelKey: 'systemMisc.statusLabels.offline' },
  inactive: { className: 'bg-red-100 text-red-800', labelKey: 'systemMisc.statusLabels.offline' },
  error: { className: 'bg-yellow-100 text-yellow-800', labelKey: 'systemMisc.statusLabels.error' },
  unknown: { className: 'bg-slate-100 text-slate-800', labelKey: 'systemMisc.statusLabels.unknown' },
};

